import { Switch } from '@mantine/core';
import { useChangeCandidateResumeActivity } from '@entities/candidates';
import { showNotification } from '@shared/utils';
import { isAxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { useCandidateResumeDeactivateModal } from '../hooks/useCandidateResumeDeactivateModal';

type CandidateResumeActivityProps = {
  candidateId: number;
  resumeId: number;
  isActive: boolean;
};

export const CandidateResumeActivity = ({
  candidateId,
  resumeId,
  isActive,
}: CandidateResumeActivityProps) => {
  const { mutateAsync: changeActivity, isPending } =
    useChangeCandidateResumeActivity();

  const updateActivity = async (nextIsActive: boolean) => {
    try {
      await changeActivity({
        candidateId,
        resumeId,
        request: { is_active: nextIsActive },
      });

      return true;
    } catch (error) {
      const responseMessage = isAxiosError<TFormErrorResponse>(error)
        ? error.response?.data.message
        : undefined;

      showNotification({
        error,
        variant: 'error',
        message:
          responseMessage ||
          `Не удалось ${
            nextIsActive ? 'активировать' : 'деактивировать'
          } профиль`,
      });

      return false;
    }
  };

  const { openCandidateResumeDeactivateModal } =
    useCandidateResumeDeactivateModal(() => updateActivity(false));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.checked) {
      void updateActivity(true);

      return;
    }

    openCandidateResumeDeactivateModal();
  };

  return (
    <Switch
      aria-label='Активность профиля'
      checked={isActive}
      onChange={handleChange}
      label={isActive ? 'Активен' : 'Неактивен'}
      disabled={isPending}
    />
  );
};
